<template>
  <form v-on:submit.prevent="saveHold" autocomplete="off">
    <div class="sm:flex sm:items-start">
      <div class="mt-3 text-left w-full">
        <h3
          class="text-lg leading-6 font-medium text-gray-900"
          id="modal-headline"
        >
          Cancel Order
        </h3>
        <div class="mt-2">
          <!-- Reason -->
          <label for="reason" class="block text-sm font-medium leading-5 text-gray-700">Reason</label>
          <select
            v-if="!reasonsLoaded"
            class="mt-1 block form-select w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            disabled
          >
            <option selected disabled value="">Loading...</option>
          </select>

          <select
            v-else
            id="reason"
            v-model="form.Reason"
            class="mt-1 block form-select w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          >
            <option :value="undefined"></option>
            <option v-for="reason in reasons" :key="reason.Text1">
              {{ reason.Text1 }}
            </option>
          </select>

          <!-- Note -->
          <label for="note" class="block text-sm font-medium leading-5 text-gray-700 mt-2">Note</label>
          <div class="relative rounded-md shadow-sm">
            <input
              id="note"
              v-model="form.Note"
              class="form-input block w-full sm:text-sm sm:leading-5"
              placeholder="Please enter a note for canceling this order."
            />
          </div>
          <!-- <label
            v-if="userCanCancelWithoutRefund"
            for="dontRefund"
            class="block text-sm font-medium leading-5 text-gray-700 mt-2"
            >Cancel without refund</label
          >
          <input
            v-if="userCanCancelWithoutRefund"
            type="checkbox"
            id="dontRefund"
            true-value="1"
            false-value="0"
            v-model="form.DontRefund"
          /> -->
        </div>

        <div class="mt-4 text-center">
          <p class="text-sm leading-5 text-red-500">
            <icon
              set="solid"
              name="exclamation"
              class="w-5 h-5 inline-block"
            />
            This action cannot be undone
          </p>
        </div>

      </div>
    </div>

    <HttpError :error="error" />

    <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
      <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
        <Button
          type="submit"
          :disabled="saving || form.Reason == null || form.Note == null"
          class="flex items-center space-x-2"
        >
          <span>Save</span>
          <LoadingSpinner v-if="saving" class="text-white" />
        </Button>
      </span>
      <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
        <Button
          class="btn btn-white"
          v-on:click-handler="$emit('onClose', true)"
        >
          Cancel
        </Button>
      </span>
    </div>
  </form>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Button from "@/components/elements/Button.vue";
import auth from "@/api/auth";

const Listing = ApiFactory.get('listings');

export default {
  props: {},
  data() {
    return {
      reasons: [],
      reasonsLoaded: false,
      saving: false,
      error: null,
      form: {
        Note: null,
        FollowUp: "Refund Issued - FULL",
        Policy: "Customer Care",
        Reason: null,
        DontRefund: false
      }
    };
  },
  computed: {
    userCanCancelWithoutRefund() {
      return auth.isUserAuthorized('admin');
    },
  },
  components: {
    Button
  },
  created() {
    Listing.get({ list: 'Adjustment Reasons - Cancel' })
      .then(response => {
        this.reasons = response.data.body;
        this.reasonsLoaded = true;
      });
  },
  methods: {
    saveHold() {
      this.saving = true;
      this.error = null;

      const order = this.$store.getters["orders/getOrder"];

      this.$store
        .dispatch("orders/cancelOrder", {
          OrderNumber: order.SourceOrderNumber,
          data: this.form
        })
        .then(() => {
          this.$emit("onClose");
        })
        .catch(e => this.error = e)
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
